// Единая точка завершения сессии: refresh-токен мёртв, работать дальше нечем.
export function endSession() {
  localStorage.clear();
  window.location.href = '/';
}

export default endSession;
